import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Define the languages supported by the application
export const LANGUAGES = ['en'];

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    resources: {
      en: {
        translation: {
          // Common translations
          common: {
            loading: 'Loading...',
            error: 'An error occurred',
            save: 'Save',
            cancel: 'Cancel',
            create: 'Create',
            delete: 'Delete',
            edit: 'Edit',
            back: 'Back',
            home: 'Home',
          },
          // Merchant profile form translations
          merchantProfile: {
            title: 'Create Merchant Profile',
            description: 'Create a new merchant profile in the ProPay simulator',
            profileName: 'Profile Name',
            profileNamePlaceholder: 'Enter profile name',
            profileNameDescription: 'A unique identifier for the merchant profile',
            paymentProcessor: 'Payment Processor',
            paymentProcessorPlaceholder: 'Enter payment processor',
            paymentProcessorDescription: 'The payment processor for this merchant profile (e.g., LegacyProPay)',
            processorData: 'Processor Data',
            addField: 'Add Field',
            fieldName: 'Field Name',
            fieldValue: 'Value',
            fieldNamePlaceholder: 'e.g., certStr',
            fieldValuePlaceholder: 'Enter value',
            creating: 'Creating...',
            createButton: 'Create Merchant Profile',
            successTitle: 'Merchant profile created successfully',
            errorTitle: 'Failed to create merchant profile',
          },
          // Navigation translations
          nav: {
            home: 'Home',
            createMerchantProfile: 'Create Merchant Profile',
            merchantProfileList: 'Merchant Profiles',
            apiDocs: 'API Documentation',
          },
          // Page translations
          pages: {
            home: {
              title: 'Welcome to ProPay Simulator Admin',
              subtitle: 'Manage merchant profiles and test ProPay integration scenarios.',
              createMerchantProfileTitle: 'Create Merchant Profile',
              createMerchantProfileDescription: 'Add new merchant profiles to the simulator',
              apiDocsTitle: 'API Documentation',
              apiDocsDescription: 'View ProPay API endpoints and examples',
              merchantProfileListTitle: 'Merchant Profiles',
              merchantProfileListDescription: 'View and manage existing merchant profiles',
              comingSoon: 'Coming Soon',
            },
          },
        },
      },
    },
  });

export default i18n;
